<dv-dialog-content>
  @if (data.bannerConfig) {
    <dv-alert-banner
      [type]="data.bannerConfig.type || 'info'"
      [isVisible]="data.bannerConfig.isVisible || true"
      [contentText]="data.bannerConfig.contentText || '' | translate" />
  }
  <dv-dynamic-form
    [elements]="data.elements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <dv-button footer-right (click)="onCancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="performSave()"
    [disabled]="!formGroup.valid || !formGroup.dirty">
    {{ 'General.Save' | translate }}
  </dv-button>
</dv-dialog-content>
